// @flow
import React, { Component } from "react"
import { Motion, spring, presets } from "react-motion"
import { Redirect } from "react-router-dom"
import {
  Modal,
  Content,
  Body,
  Header,
  PrimaryHeading,
  Footer,
  SubHeading
} from "../UI/Modal"
import Loader from "../UI/Loader"
import { PrimaryButton, SecondaryButton } from "../UI/Buttons"
import { refreshTokens, refreshToken, isAdmin, logoutUser } from "../Auth"
import type { RouterHistory } from "react-router-dom"

type Props = {
  history: RouterHistory
}

const delay = (time: number) =>
  new Promise(resolve => setTimeout(() => resolve(), time))

type State = { loading: boolean }

class Pending extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { loading: false }
  }

  forceTokenRefresh = async () => {
    this.setState(() => ({ loading: true }))
    await refreshTokens(refreshToken())
    await delay(5000)
    this.setState(() => ({ loading: false }))
  }

  logout = () => {
    const { history } = this.props
    logoutUser()
    history.push("/")
  }

  render() {
    const { loading } = this.state
    return isAdmin() ? (
      <Redirect to="/admin" />
    ) : (
      <Modal>
        <form onSubmit={e => e.preventDefault()}>
          <Motion
            key="body"
            defaultStyle={{ y: -100, a: 0 }}
            style={{
              y: spring(0, presets.wobbly),
              a: spring(1, presets.noWobble)
            }}
          >
            {is => (
              <Body
                style={{
                  transform: `translate(0, ${is.y}px`,
                  opacity: is.a
                }}
              >
                <Loader loading={loading}>
                  <Header>
                    <PrimaryHeading>Kiosk Admin</PrimaryHeading>
                    <SubHeading>Pending Admin Approval</SubHeading>
                  </Header>
                  <Content>
                    <p>
                      You're logged in to your account but it has not been
                      approved for admin usage yet.
                    </p>
                    <PrimaryButton
                      block={true}
                      enabled={!loading}
                      onClick={this.forceTokenRefresh}
                    >
                      Refresh Status
                    </PrimaryButton>
                  </Content>
                  <Footer>
                    <SecondaryButton
                      block={true}
                      enabled={!loading}
                      onClick={this.logout}
                    >
                      Logout
                    </SecondaryButton>
                  </Footer>
                </Loader>
              </Body>
            )}
          </Motion>
        </form>
      </Modal>
    )
  }
}

export default Pending



// WEBPACK FOOTER //
// ./src/PublicArea/Pending.js